import React from 'react'
import moment from 'moment';
import { WizTableForm, WizClassifySelect } from '@/containers/common';

//配置项
let componentName = 'subjectiveReview'
let ref;

const columns = (commentData) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '考试名称',
      name: 'title',
      dataIndex: 'title',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '考试分类',
      name: 'categoryType',
      tableItem: {}
    },
    {
      title: '考试分类',
      name: 'categoryTypeIds',
      searchItem: {
        type: 'diy',
        diy: WizClassifySelect,
        returnKey: true,
        wizTreeSelectListProps: {
          itemProps: {
            icon: 'unordered-list',
            title: '考试分类',
            tips: '请选择考试分类'
          },
          treeProps: { checkStrictly: true },
          checkable: false
        },
        apiProps: { type: 0 },
        selectProps: {
          placeholder: '请选择考试分类'
        },
      }
    },
    {
      title: '考试类型',
      name: 'examType',
      tableItem: {},
      searchItem: {
        type: 'select'
      },
      dict: [
        { code: 0, codeName: '独立考试' },
        { code: 1, codeName: '课程考试' },
      ]
    },
    {
      title: '考试时间',
      name: 'timeInterval',
      dataIndex: 'timeInterval',
      searchItem: {
        type: 'date~',
        showTime: true,
      },
    },
    {
      title: '需要批阅',
      name: 'needReview',
      dataIndex: 'needReview',
      dict: [
        { code: 0, codeName: '不需要' },
        { code: 1, codeName: '需要' },
      ],
      searchItem: {
        type: 'select'
      }
    },
    {
      title: '开始时间',
      name: 'startDate',
      dataIndex: 'startDate',
      tableItem: {}
    },
    {
      title: '结束时间',
      name: 'endDate',
      dataIndex: 'endDate',
      tableItem: {}
    },
    {
      title: '状态',
      name: 'status',
      dataIndex: 'status',
      tableItem: {},
      dict: [
        {code: 0, codeName: '草稿'},
        {code: 1, codeName: '已发布'},
        {code: 2, codeName: '已关闭'}
      ]
    },
    {
      title: '已批阅数',
      name: 'reviewNum',
      dataIndex: 'reviewNum',
      tableItem: {}
    },
    {
      title: '待批阅数',
      name: 'unreviewNum',
      dataIndex: 'unreviewNum',
      tableItem: {}
    },
  ]
}
  ;

const templateConfig = () => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns(),
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ],
          dataFormat: (v) => {
            let value = Object.assign([], v)
            if (value['timeInterval'] && value['timeInterval'].length === 2) {
              value['startDate'] = moment(value['timeInterval'][0]).format('YYYY-MM-DD HH:mm:00')
              value['endDate'] = moment(value['timeInterval'][1]).format('YYYY-MM-DD HH:mm:00')
            }
            return value
          },
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['look'],
        rowOperateView: [
          {
            key: 'look',
            custom: true,
            params: { children: '查看' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/online/subjectiveReview/record'
              }
            }
          },
        ]
      }
    }
  }
};


const apis = () => {
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { pageNum: 1, pageSize: 10 }
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    }
  };
}

let reduxTemplateCofig = (args) => {

  return {
    apis: apis(),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
